/*
 * @Author: keman.chen
 * @Date: 2023-08-25 11:35:51
 * @LastEditTime: 2023-09-26 17:56:48
 * @LastEditors: keman.chen
 * @Description: 基础配置
 * @FilePath: /monitor/packages/shared/src/config.ts
 */
import { version } from '../package.json'

export const SDK_NAME = '@tr-infra/pilot'
export const SDK_VERSION = version
